module.exports = __webpack_public_path__ + "static/img/testBgItem1.682db69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testBgItem1.png
// module id = Iw/P
// module chunks = 1